export default __webpack_public_path__ + "static/media/home-img14.d53ef3b1.png";